import React, { Component } from 'react';
import './App.css';
import Brick from './Brick'
import BlendArea from './BlendArea'
import BrickArea from './BrickArea';
import Bricks from './bricks';
import MortarColor from './MortarColor'
import Accent from './Accent'
import findIndex from 'array.prototype.findindex';

class App extends Component {
  constructor(props) {
    super(props);
    this.numberOfBricksAllowedToBeSelected = 3;
    this.state = {
      bricks: Bricks,
      selectedBrickIndexes: [],
      accentBrickId:"",
      mortarColor: "light",
      accentEveryRow:5
    };

    findIndex.shim();
 
  }

  colorClicked = (color) => {
    this.setState({
      mortarColor: color
    });
  }

  perRowAccentChanged = (rowEvery) => {
    rowEvery = parseInt(rowEvery);
    this.setState({
      accentEveryRow: rowEvery
    });
  }
  
  ratioChanged = (brick, newRatio) => {
    var brickIndex = this.state.bricks.findIndex(x => x.id === brick.id);

    // 1. Make a shallow copy of the items
    let bricks = [...this.state.bricks];
    // 2. Make a shallow copy of the item you want to mutate
    let item = { ...bricks[brickIndex] };
    // 3. Replace the property you're intested in
    item.ratio = (item.ratio !== undefined) ? newRatio : 100;
    // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    bricks[brickIndex] = item;
    // 5. Set the state to our new copy
    this.setState({
      bricks: bricks,
    });

  }


  accentChanged = (brickId) => {

      this.setState({
        accentBrickId: brickId,
      });
    
  }


  brickClicked = (clickedBrick) => {

    //loop through all bricks

    //mark current brick as selected or not

    //update ratios on selcted bricks

    //put the back



    var brickIndex = this.state.bricks.findIndex(x => x.id === clickedBrick.id);

    if (clickedBrick.selected === true || (this.state.selectedBrickIndexes.length < this.numberOfBricksAllowedToBeSelected)) {

      let isAddingBrick = clickedBrick.selected === false || clickedBrick.selected === undefined;

      let selectedBrickIndexes = [...this.state.selectedBrickIndexes];

      if (isAddingBrick) {
        selectedBrickIndexes = [...selectedBrickIndexes, brickIndex];
      }
      else {

        selectedBrickIndexes = selectedBrickIndexes.filter(b => b !== brickIndex);
      }

      // 1. Make a shallow copy of the items
      let bricks = [...this.state.bricks];
      // 2. Make a shallow copy of the item you want to mutate
      let item = { ...bricks[brickIndex] };
      // 3. Replace the property you're intested in
      item.selected = (item.selected !== undefined) ? !item.selected : true;
      // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
      bricks[brickIndex] = item;


      if (selectedBrickIndexes.length === 1) {
        bricks[selectedBrickIndexes[0]].ratio = 100;
      }
      else if (selectedBrickIndexes.length > 1) {
        let summedRatios = 0;
        selectedBrickIndexes.forEach((sbi, i) => {
          //debugger;
          let newRatio = Math.round(Math.round(100 / selectedBrickIndexes.length) / 10) * 10; //this rounds to the nearest 10

          if (i === selectedBrickIndexes.length - 1) //last one
          {
            newRatio = 100 - summedRatios;
          }

          bricks[sbi].ratio = newRatio;

          summedRatios += newRatio;
        });
      }

      // 5. Set the state to our new copy
      this.setState({
        bricks: bricks,
        selectedBrickIndexes: selectedBrickIndexes
      });
    }
  }

  render() {
    return (
      <div className="App">
        <div className="row">
          <div className="col-12 col-sm-6  brickCol">
            <BrickArea {...this.state} numberOfBricksAllowedToBeSelected={this.numberOfBricksAllowedToBeSelected} onBrickClicked={this.brickClicked} />
          </div>
          <div className="col-12 col-sm-6 mt-2 mt-sm-5 blendCol">
            <div>
              <div className={'blendarea mortar-' + this.state.mortarColor}></div>
              <BlendArea {...this.state} />
            </div>
            <div>
              <h3>2.) Choose Mortar Color</h3>
              <MortarColor onColorClick={this.colorClicked} />
            </div>
            <div>
              <h3>3.) Set Color Percentages</h3>
              <div style={{ position: "relative" }}>
                {this.state.bricks.map(function (brick, index) {
                  if (brick.selected === true) {
                    return <Brick {...brick} key={index} onBrickClick={this.brickClicked} showRatio={true} ratioEnabled={true} ratioChanged={this.ratioChanged} />
                  }
                  else {
                    return null;
                  }
                }, this)}

                {[...Array(this.numberOfBricksAllowedToBeSelected - this.state.selectedBrickIndexes.length)].map(function (brick, index) {
                  return <Brick empty={true} key={index} showRatio={true} ratioEnabled={false} />
                }, this)}
              </div>
            </div>
            <div>
              <h3>4.) Choose Accent Color <small className="text-muted">*optional</small></h3>

              <Accent {...this.state} accentChanged={this.accentChanged} perRowAccentChanged={this.perRowAccentChanged} />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default App;
